import { render, staticRenderFns } from "./asRegToCenRecieve.vue?vue&type=template&id=03e5f5cb&scoped=true&"
import script from "./asRegToCenRecieve.vue?vue&type=script&lang=js&"
export * from "./asRegToCenRecieve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e5f5cb",
  null
  
)

export default component.exports